import { useQuery } from 'react-query';

import { DeliveryServices } from '@/domain/models/DeliveryService';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { DeliveryServiceService } from '@/services/Enterprise/DeliveryService';

interface UseDeliveryService {
  deliveryServices?: DeliveryServices;
  isLoading: boolean;
  isError: Error | null;
}

export const useDeliveryServiceLinkEnterprise = (): UseDeliveryService => {
  const deliveryServiceService = new DeliveryServiceService(getClient());

  const {
    data: deliveryServices,
    error,
    isLoading,
  } = useQuery<DeliveryServices, Error>('deliveryServices', () =>
    deliveryServiceService
      .list()
      .catch((error: Error) => errorHandler({ error }))
  );

  return {
    deliveryServices,
    isLoading,
    isError: error,
  };
};
